export default "__VITE_ASSET__21ee03e0__"